import { render, staticRenderFns } from "./TicketReplyTemplateButton.vue?vue&type=template&id=506e3b52&scoped=true&"
import script from "./TicketReplyTemplateButton.vue?vue&type=script&lang=ts&"
export * from "./TicketReplyTemplateButton.vue?vue&type=script&lang=ts&"
import style0 from "./TicketReplyTemplateButton.vue?vue&type=style&index=0&id=506e3b52&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "506e3b52",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/winfakt-authentication-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('506e3b52')) {
      api.createRecord('506e3b52', component.options)
    } else {
      api.reload('506e3b52', component.options)
    }
    module.hot.accept("./TicketReplyTemplateButton.vue?vue&type=template&id=506e3b52&scoped=true&", function () {
      api.rerender('506e3b52', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ticket/TicketReplyTemplateButton.vue"
export default component.exports